import { FunctionComponent, PropsWithChildren } from 'react';
import { Container } from '../layout/Container';
import { Theme } from '../layout/Theme';
import { HeaderProps } from '../types';
import { Header } from '../Header';

export const PageTabless: FunctionComponent<PropsWithChildren<{ headerProps?: HeaderProps }>> = ({
  headerProps,
  children,
}) => (
  <Theme>
    <>
      {!headerProps ? null : <Header {...headerProps} />}
      <Container>{children /* <-- this is the actual content of the legal document */}</Container>
    </>
  </Theme>
);
